function state() {
  return {
    addProductCategory: {
      name: "",
      industry: "",
      icon: "",
      description: "",
    },
    editProductCategory: {
      id: "",
      name: "",
      industry: "",
      icon: "",
      description: "",
    },
    productCategoryList: [],
    industryList: [],
    uploadProgress: 0,
    isNewInsurerCreated: false,
    insurerDetail: {},
  };
}

export default state;
